import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=5f3fd08b&"
import script from "./Badges.vue?vue&type=script&setup=true&lang=js&"
export * from "./Badges.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Badges.vue?vue&type=style&index=0&id=5f3fd08b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports